module.exports = __webpack_public_path__ + "/images/2NHoF00.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/thumb-up.png
// module id = 244
// module chunks = 0